import nodeApi from '../utils/nodeApiClient';

const renewalsApi = {
  list: (params) => nodeApi.get('/renewals', { params }),
  getEligibility: (saleOrderId) => nodeApi.get(`/renewals/eligibility/${saleOrderId}`),
  create: (data) => nodeApi.post('/renewals', data),
  getById: (id) => nodeApi.get(`/renewals/${id}`),
  getQuotationDetails: (id) => nodeApi.get(`/renewals/${id}/quotation-details`)
};

export default renewalsApi;
